const date = new Date();
const day = date.getDate() < 10 ? ('0' + (date.getDate())) : date.getDate().toString();
const month = date.getUTCMonth() + 1 < 10 ? ('0' + (date.getUTCMonth() + 1)) : date.getUTCMonth() + 1;
const year = date.getFullYear().toString();

export {day, month, year};
